// Generated by purs version 0.15.15
import * as Control_Category from "../Control.Category/index.js";
import * as Ouroboros_Models_Ui_EmailValidationPhase from "../Ouroboros.Models.Ui.EmailValidationPhase/index.js";
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
var readState = function (v) {
    return v;
};
var errorMessageFromOption = /* #__PURE__ */ Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
    return "";
})(/* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn));
var bodyPhaseFromStatus = function (value) {
    if (value === "loading") {
        return Ouroboros_Models_Ui_EmailValidationPhase.emailValidationPhaseNamespace.loading;
    };
    if (value === "success") {
        return Ouroboros_Models_Ui_EmailValidationPhase.emailValidationPhaseNamespace.success;
    };
    if (value === "error") {
        return Ouroboros_Models_Ui_EmailValidationPhase.emailValidationPhaseNamespace.error;
    };
    return Ouroboros_Models_Ui_EmailValidationPhase.emailValidationPhaseNamespace.idle;
};
var buildEmailValidationViewProps = function (input) {
    var onTokenRouteChange = function (tokenOption) {
        return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
            return input.kernel.controller.runValidation("");
        })(function (token) {
            return input.kernel.controller.runValidation(token);
        })(tokenOption);
    };
    var navigateTo = function (route) {
        return function (v) {
            return input.kernel.navigate(route);
        };
    };
    return {
        bodyPhase: bodyPhaseFromStatus(readState(Ouroboros_Programs_Capabilities.stateHandleRead(input.kernel.status))),
        errorMessage: errorMessageFromOption(readState(Ouroboros_Programs_Capabilities.optionStateHandleRead(input.kernel.errorMessage))),
        onTokenRouteChange: onTokenRouteChange,
        onNavigateToHome: navigateTo(input.homeRoute),
        onNavigateToLogin: navigateTo(input.loginRoute)
    };
};
export {
    buildEmailValidationViewProps
};
//# sourceMappingURL=index.js.map
